import {EventEmitter, Injectable}   from "@angular/core";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { AuthService } from "../../base-module/base-service/auth.service";
import { Observable } from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class TipoCustoService {

    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService,
                private _http: HttpClient,
                public utilitesService: UtilitesService) {
    }

    /**
     * Tipo de Custos por id
     * @param id ID da Tipo de Custos
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "tipo-custos/" + id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Custos
     * @param id ID da Tipo de Custos
     */
    getAll(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "tipo-custos"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Lista de Tipo de Custos
     * @param id ID da Tipo de Custos
     */
    search(params: any): Observable<any> {

        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if(paramHttp != null && paramHttp != ""){
            env = "?"+paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "tipo-custos"+env, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Delete de Tipo de Custos
     * @param id ID da Tipo de Custos
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "tipo-custos/"+id, { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Cadastra Tipo de Custos
     * @param params Json Tipo de Custos
     */
    create(params: any):Observable<any>{
        return this._http.post(this.utilitesService.urlPrefix + "tipo-custos", JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

    /**
     * Atualiza Tipo de Custos
     * @param params Json Tipo de Custos
     */
    update(id: number, params: any):Observable<any>{
        return this._http.put(this.utilitesService.urlPrefix + "tipo-custos/"+id, JSON.stringify(params), { headers: this.authService.getAuthHeaders() });
    }

}
